import React from "react";
import { MagnifyingGlass } from "../../../../../assets/Icons/MagnifyingGlass";
import "./TableSearch.scss";

// Match only the columns shown in the table, using their displayed values.
export const searchTableRows = (rows, columns, searchTerm, getValue = (row, column) => row[column]) => {
  const query = searchTerm.trim().toLowerCase();
  if (!query) return rows;

  return rows.filter((row) =>
    columns.some((column) => {
      const value = getValue(row, column);
      return value != null && String(value).toLowerCase().includes(query);
    }),
  );
};

export const TableSearch = ({ value, onChange, placeholder = "Search table..." }) => (
  <div className="regional-lead-search-container">
    <span className="search-icon" aria-hidden="true">
      <MagnifyingGlass width={16} height={16} color="#737387" />
    </span>
    <input
      type="search"
      className="regional-lead-search-input"
      aria-label="Search table"
      placeholder={placeholder}
      value={value}
      onChange={(event) => onChange(event.target.value)}
    />
    {value && (
      <button type="button" className="search-clear-btn" onClick={() => onChange("")} aria-label="Clear search">
        ×
      </button>
    )}
  </div>
);